import { SubmitButton } from '@/components/blocks/buttons/SubmitButton';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle2 } from 'lucide-react';
import { useEffect } from 'react';
import { toast } from 'sonner';
import { useSchemaFormSlots } from '../contexts';

export interface InquiryFormTemplateProps {
  title: string;
  description: string;
  successMessage?: string;
  errorMessage?: string;
}

export function InquiryFormTemplate({
  title,
  description,
  successMessage = 'Your request has been submitted successfully.',
  errorMessage = 'Something went wrong. Please try again.',
}: InquiryFormTemplateProps) {
  const { renderFields, isSubmitting, isSubmitted, submitFailed } = useSchemaFormSlots();
  const showSuccess = isSubmitted && !submitFailed;

  useEffect(() => {
    if (submitFailed) {
      toast.error(errorMessage, { duration: 5000, closeButton: true });
    }
  }, [submitFailed]);

  if (showSuccess) {
    return (
      <div className="flex justify-center">
        <Alert className="w-fit border-alert-success-border bg-alert-success-bg text-alert-success-text">
          <CheckCircle2 className="h-4 w-4 text-alert-success-text" />
          <AlertDescription className="text-alert-success-text">{successMessage}</AlertDescription>
        </Alert>
      </div>
    );
  }

  return (
    <div className="flex justify-center">
      <Card className="w-full max-w-2xl">
        <CardHeader className="px-8 text-center sm:px-10 md:px-14 lg:px-20">
          <CardTitle className="font-raleway text-data-card-xl font-bold">{title}</CardTitle>
          <CardDescription className="text-left">{description}</CardDescription>
        </CardHeader>
        <CardContent className="px-8 sm:px-10 md:px-14 lg:px-20">
          {renderFields(true)}
          <div className="col-span-full flex flex-col items-center gap-4 pt-4">
            <SubmitButton label="Submit" isLoading={isSubmitting} />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
